import { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import { Button } from "@/components/ui/button";

export const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const navLinks = [
  { href: "#eventi", label: "EVENTI" },
  { href: "#chi-siamo", label: "CHI SIAMO" },
  { href: "#galleria", label: "GALLERIA" },
  { href: "#regolamento", label: "REGOLAMENTO" },
  { href: "#contatti", label: "CONTATTI" }];


  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
    setIsMobileMenuOpen(false);
  };

  return (
    <nav
      data-testid="navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
      isScrolled ? "bg-tactical-bg/95 backdrop-blur-md border-b border-tactical-border" : "bg-transparent"}`
      }>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <a
            href="#"
            data-testid="logo-link"
            className="flex items-center gap-3 group"
            onClick={(e) => {
              e.preventDefault();
              window.scrollTo({ top: 0, behavior: "smooth" });
            }}>

            <img
              src="/logo.png"
              alt="Ghost Division Logo"
              className="w-12 h-12 object-contain transition-transform duration-300 group-hover:scale-110" />

            <span className="font-heading font-bold text-xl tracking-wider !text-[#444444]">
              GHOST<span className="text-tactical-primary">DIVISION A.S.D.</span>
            </span>
          </a>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
            <button
              key={link.href}
              data-testid={`nav-${link.href.replace('#', '')}`}
              onClick={() => scrollToSection(link.href)}
              className="nav-link font-heading font-semibold text-sm tracking-widest text-tactical-text-muted hover:text-tactical-primary">

                {link.label}
              </button>
            ))}
          </div>

          {/* Mobile Menu Button */}
          <Button
            variant="ghost"
            size="icon"
            data-testid="mobile-menu-button"
            className="md:hidden text-tactical-text hover:text-tactical-primary hover:bg-tactical-surface"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}>

            {isMobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </Button>
        </div>

        {/* Mobile Navigation */}
        {isMobileMenuOpen &&
        <div
          data-testid="mobile-menu"
          className="md:hidden bg-tactical-surface border-t border-tactical-border">

            <div className="px-4 py-6 space-y-4">
              {navLinks.map((link) => (
            <button
              key={link.href}
              data-testid={`mobile-nav-${link.href.replace('#', '')}`}
              onClick={() => scrollToSection(link.href)}
              className="block w-full text-left font-heading font-semibold text-sm tracking-widest text-tactical-text-muted hover:text-tactical-primary py-2">

                  {link.label}
                </button>
            ))}
            </div>
          </div>
        }
      </div>
    </nav>);

};